import { useContext } from "react";
import { AuthContext } from "@/contexts/AuthProvider";

export function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth can only be used inside an AuthProvider");
  }

  return context;
}
